import script from "./TeamPropertisForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamPropertisForm.vue?vue&type=script&lang=ts&setup=true"

import "./TeamPropertisForm.vue?vue&type=style&index=0&id=938a566e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938a566e"]])

export default __exports__